<div class="text-faded-30 max-w-[300px] text-center md:text-justify md:max-w-screen-md mx-auto text-xs grid grid-flow-row gap-y-5 auto-rows-max p-8">
    <div class="flex justify-center gap-3 md:gap-10 text-faded-80">
        <a href="/about" class="hover:text-ponder-bright">About</a>
        <div class="vertical-separator-small"></div>
        <a href="/about#contact" class="hover:text-ponder-bright">Contact</a>
        <div class="vertical-separator-small"></div>
        <a href="/news" class="hover:text-ponder-bright">News</a>
        <div class="vertical-separator-small"></div>
        <a href="/terms" class="hover:text-ponder-bright">Terms</a>
    </div>
    <div><!-- empty --></div>
    <div>
        Portions of Ponder are unofficial Fan Content permitted under the Wizards of the Coast <a href="https://company.wizards.com/en/legal/fancontentpolicy">Fan Content Policy</a>. The literal and graphical information presented on this site about Magic: The Gathering, including card images and mana symbols, is copyright Wizards of the Coast, LLC. Ponder is not produced by or endorsed by Wizards of the Coast.
    </div>
    <div>
        © 2025 Ponder TCG, LLC
    </div>
</div>